// extracted by mini-css-extract-plugin
export default {"logoGoogleSafe":"logoGoogleSafe__I2NpR","customBorder":"customBorder__PHuOm"};